<template>
  <multiselect
    :value="selectedValues"
    :options="options"
    :multiple="multiple"
    label="text"
    track-by="value"
    @input="selectionUpdated"
  />
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: [Array, String],
    },
    options: Array,
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedValues() {
      if (Array.isArray(this.value))
        return this.options.filter((option) =>
          this.value.includes(option.value),
        );

      return this.options.filter((option) => this.value === option.value);
    },
  },
  methods: {
    selectionUpdated(value) {
      if (value == null) {
        value = [];
      }
      const values = Array.isArray(value) ? value : [value];
      const updatedValues = values.map((item) => item.value);
      this.$emit('input', updatedValues);
    },
  },
};
</script>
